import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { Subscription } from "@/schema/subscription";

interface SubscriptionStore {
  subscription: Subscription | null;
  setSubscription: (subscription: Subscription | null) => void;
}

export const useSubscriptionStore = create<SubscriptionStore>()(
  immer((set) => ({
    subscription: null,
    setSubscription: (subscription: Subscription | null) => {
      set((state) => {
        state.subscription = subscription;
      });
    },
  }))
);
